import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center gap-x-4 gap-y-2" }
const _hoisted_2 = { class: "text-sm/6" }
const _hoisted_3 = { class: "flex flex-1 justify-end" }

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import { computed, ref } from "vue";
import EditableElement from "@/views/page/EditableElement.vue";
import Background from "@/views/blocks/banner/components/background/Background.vue";
import DismissButton from "@/views/blocks/banner/components/dismiss-button/DismissButton.vue";
import Title from "@/views/blocks/banner/components/title/Title.vue";
import Description from "@/views/blocks/banner/components/description/Description.vue";
import DotIcon from "@/views/blocks/banner/components/dot-icon/DotIcon.vue";
import PrimaryButton from "@/views/blocks/shared/section/buttons/primary-button/PrimaryButton.vue";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import { WithButtonProps } from "./WithButtonProps";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithButton',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const isVisible = ref(true);

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createBlock(Section, {
        key: 0,
        id: _ctx.block.webId,
        "background-color": styleValues.value.background,
        scrollAnimationType: 'none'
      }, {
        default: _withCtx(() => [
          _createVNode(Background, {
            "background-color": styleValues.value.background,
            "is-with-effect": true,
            class: "sm:before:flex-1"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, [
                  (!dataValues.value.title.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 0,
                        blockId: _ctx.block.id,
                        "field-name": "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Title, {
                            text: dataValues.value.title.data.text,
                            "text-color": styleValues.value.text
                          }, null, 8, ["text", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.title.isHidden && !dataValues.value.description.isHidden)
                    ? (_openBlock(), _createBlock(DotIcon, {
                        key: 1,
                        style: _normalizeStyle({
                            color: styleValues.value.text,
                        })
                      }, null, 8, ["style"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.description.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 2,
                        blockId: _ctx.block.id,
                        "field-name": "description"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Description, {
                            text: dataValues.value.description.data.text,
                            "text-color": styleValues.value.text
                          }, null, 8, ["text", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true)
                ]),
                (!dataValues.value.button.isHidden)
                  ? (_openBlock(), _createBlock(EditableElement, {
                      key: 0,
                      blockId: _ctx.block.id,
                      "field-name": "button"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(PrimaryButton, {
                          label: dataValues.value.button.data.label,
                          href: dataValues.value.button.data.href,
                          "background-color": styleValues.value.brand,
                          "text-color": styleValues.value.background,
                          "show-arrow": true,
                          class: "flex-none rounded-full px-3.5 py-1 text-sm font-semibold"
                        }, null, 8, ["label", "href", "background-color", "text-color"])
                      ]),
                      _: 1
                    }, 8, ["blockId"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(DismissButton, {
                  "accent-color": styleValues.value.text,
                  onDismiss: _cache[0] || (_cache[0] = ($event: any) => (isVisible.value = false))
                }, null, 8, ["accent-color"])
              ])
            ]),
            _: 1
          }, 8, ["background-color"])
        ]),
        _: 1
      }, 8, ["id", "background-color"]))
    : _createCommentVNode("", true)
}
}

})